import React, { useState, useEffect } from "react";

/**
 * Cookie consent banner — the UI over window.flowConsent (see ../consent.js), matching
 * the fleet's flow-cookie-consent banner: Accept All / Reject All plus the policy link.
 * Every decision about what a choice means lives in consent.js; this component only
 * shows the question and forwards the answer.
 */
const CookieNotice = () => {

  // Assume decided until we can read storage, so the banner never flashes for a
  // returning visitor who has already chosen.
  const [decided, setDecided] = useState(true);
  useEffect(() => { setDecided(!!(window.flowConsent && window.flowConsent.stored())); }, []);

  const choose = (accept) => {
    if (window.flowConsent) {
      if (accept) { window.flowConsent.acceptAll(); } else { window.flowConsent.rejectAll(); }
    }
    setDecided(true);
  };

  // "You can switch them off here at any time" has to stay true after a choice is made:
  // the reopen trigger is the later opt-out that makes analytics-by-default defensible
  // (the plugin's floating trigger, in this site's idiom).
  return (
    decided ?
      <button type="button" aria-label="Cookie preferences" style={{ "position": "fixed", "left": "1rem", "bottom": "1rem", "z-index": "9999", "padding": "0.4rem 0.9rem", "border": "none", "border-radius": "999px", "background-color": "rgb(114, 168, 78)", "color": "white", "cursor": "pointer" }} onClick={() => setDecided(false)}>Cookie preferences</button>
      :
      <div id="cookie_notice" role="dialog" aria-modal="false" aria-labelledby="cookie_notice_heading" style={{ "-webkit-text-align": "center", "position": "fixed", "inset": "auto 0px 0px", "padding-top": "1rem", "padding-left": "1rem", "padding-right": "1rem", "z-index": "9999", "background-color": "rgb(114, 168, 78)", "color": "white !important" }}>
        <div className="shell">
          <p id="cookie_notice_heading" className="section__title h4" style={{"color": "white", "margin-bottom": "0.25rem"}}>We value your privacy</p>
          <p className="section__subtitle" style={{"color": "white", "margin-bottom": "1rem"}}>We use cookies to enhance your browsing experience and analyse our traffic. Analytics cookies are on by default; you can switch them off here at any time. By clicking &quot;Accept All&quot;, you also consent to marketing cookies.</p>
          <button id="acceptButton" className="btn btn--white-green" style={{"margin-right": "2rem", "margin-bottom": "1rem"}} onClick={() => choose(true)}>Accept All</button>
          <button id="rejectButton" className="btn" style={{"background": "transparent", "border": "1px solid white", "color": "white", "margin-right": "2rem", "margin-bottom": "1rem"}} onClick={() => choose(false)}>Reject All</button>
          <a style={{"color": "white", "margin-bottom": "1rem", "text-decoration": "underline"}} href="/cookie-policy" target="_blank" rel="noreferrer">View Cookie Policy</a>
        </div>
      </div>
  )
}

export default CookieNotice;
